import React from 'react';
import SelectInput from './select_input';
import SelectInputADG3 from './select_input_adg3';

export default function(props) {
  return props.adg3 ? (
    <SelectInputADG3 {...props} />
  ) : (
    <SelectInput {...props} />
  );
}
